import { RequestObject } from 'jsonrpc-lite'
import z from 'zod';
import api from '@/app/api'
import {
    jsonRpcErrorResponseSchema,
    jsonRpcErrorWithDataResponseSchema,
    JsonRpcErrorWithDataResponse,
    jsonRpcErrorWithValidationResponseSchema,
    JsonRpcErrorWithValidationResponse,
    LKKJsonRpcErrorWithDataResponseSchema,
    LKKJsonRpcErrorWithDataResponse
} from './schema'
import { useUserStore } from '@/stores/user';
import { API_URL, AnalyticsAvailablePeriod, analyticsAvailablePeriods } from './constants'

export const jsonRpcErrorHandler = (response: any) => {
    const { success, data } = jsonRpcErrorResponseSchema.safeParse(response)
    if (!success) return response

    switch (data.error.code) {
        // todo: нужно добавить остальные коды ошибок и реакцию на них
        case -32002: { // "Token has expired"
            const store = useUserStore.getState()
            store.logout()
            window.location.reload();
        }
    }

    // После рефайкторинга раскомментировать
    // throw new Error(data.error.message)

    // После рефайкторинга удалить
    throw {
        jsonrpc: response.jsonrpc || "2.0",
        id: response.id || null,
        error: response.error
    };
};

// TODO: добавить хендлер для обработки ошибок HTTP

// @deprecated Функция будет удалена после проведения рефакторинга api
export const errorHandler = (error: any) => {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
        errorMessage = error.error.message;
    } else if (error?.error && typeof error.error === 'string') {
        throw new Error(error.error);
    } else if (error?.error?.message && typeof error.error.message === 'string') {
        throw new Error(error.error.message, { cause: error })
    } else if (error instanceof z.ZodError) {
        throw new Error("Полученные данные не соответствуют ожидаемой схеме", { cause: error })
    } else {
        errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    throw new Error(errorMessage);
};

export const createJsonRPCRequest = async <M extends (data: unknown) => unknown>(
    body: RequestObject | RequestObject[],
    validator: M = ((data) => data) as M): Promise<ReturnType<M>> => {
    try {
        const response = await api.post(API_URL, JSON.stringify(body));
        const processedData = jsonRpcErrorHandler(response);
        return await validator(processedData.result) as ReturnType<M>;
    } catch (error: any) {
        return errorHandler(error);
    }
}

export const parseSchema = <S extends z.ZodType>(getSchema: () => S) =>
    async (data: unknown): Promise<z.infer<S>> => {
        try {
            return await getSchema().parseAsync(data)
        } catch (e: unknown) {
            if (e instanceof z.ZodError) e.cause = data
            throw e
        }
    }

export const analyticsPeriodParamGuard = (value: string) : value is AnalyticsAvailablePeriod =>
    analyticsAvailablePeriods.includes(value as AnalyticsAvailablePeriod)

export const jsonRpcErrorWithDataMsgTypeGuard = (error: unknown): error is JsonRpcErrorWithDataResponse => {
    return jsonRpcErrorWithDataResponseSchema.safeParse(error).success
}

export const LKKJsonRpcErrorWithDataMsgTypeGuard = (error: unknown): error is LKKJsonRpcErrorWithDataResponse => {
    return LKKJsonRpcErrorWithDataResponseSchema.safeParse(error).success
}

export const jsonRpcErrorWithValidationResponseTypeGuard = (error: unknown): error is JsonRpcErrorWithValidationResponse => {
    return jsonRpcErrorWithValidationResponseSchema.safeParse(error).success
}